import { useState, useEffect } from 'react';
import '../../../styles/Auth/purchase.css';
import SupplierSelect from "../../Challange/SupplierSelect.jsx";
import { postData, getData, putData, deleteData } from '../../../webService/webservice.js';
import { useStore } from "../../../Context/context.jsx";
import { toast } from "react-toastify";
import { Typography } from "@mui/material";

const PurchaseHeader = ({ onApplyFilters }) => {
    const role = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const initialStoreId = adminStoreIds[0] || "";
    const token = localStorage.getItem("Token");
    const [suppliers, setSuppliers] = useState([]);

    const { selectedStoreId, setSelectedStoreId } = useStore();
    const [filters, setFilters] = useState({
        startDate: "",
        endDate: "",
        supplierId: "",
        supplierName: ""
    });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFilters(prev => ({ ...prev, [id]: value }));
    };

    const handleClear = () => {
        const empty = {
            startDate: "",
            endDate: "",
            supplierId: "",
            supplierName: ""
        };

        setFilters(empty);
        localStorage.removeItem("headerFilters");

        if (typeof onApplyFilters === "function") {
            onApplyFilters({});
        }
    };

    const handleApply = () => {
        localStorage.setItem("headerFilters", JSON.stringify(filters));
        if (typeof onApplyFilters === "function") {
            onApplyFilters(filters);
        }
    };

    useEffect(() => {
        fetchSuppliers();
    }, [selectedStoreId]);

    const fetchSuppliers = async () => {
        try {
            const params = {};
            if (selectedStoreId?.length === 24) {
                params.storeId = selectedStoreId;
            }

            const res = await getData("suppliers/suppliers", params, token);
            setSuppliers(res?.data?.results || []);
        } catch (err) {
            console.error("Supplier fetch failed", err);
            setSuppliers([]);
        }
    };




    return (

        <>
            <div className='booking-filter-container'>

                <div className="booking-filter-header">
                    <div className="filter-title-section">
                        <Typography variant="h6">Filters</Typography>
                        <p className="filter-subtitle">Refine your purchase search</p>
                    </div>
                </div>
                <div className="Date">
                    <div className="start-Date">
                        <label>Start Date</label>
                        <input
                            type="date"
                            id="startDate"
                            className="purchase-date-input"
                            value={filters.startDate}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="end-Date">
                        <label>End Date</label>
                        <input
                            type="date"
                            id="endDate"
                            className="purchase-date-input"
                            value={filters.endDate}
                            onChange={handleChange}
                        />
                    </div>



                    <div className="purchase-input-filter">
                        <label className="input-label">Supplier</label>

                        <select
                            className="purchase-input"
                            value={filters.supplierId}
                            onChange={(e) => {
                                const selectedId = e.target.value;
                                const supplier = suppliers.find(s => s._id === selectedId);

                                setFilters(prev => ({
                                    ...prev,
                                    supplierId: selectedId,
                                    supplierName: supplier?.supplierName || ""
                                }));
                            }}
                        >
                            <option value="">All Suppliers</option>

                            {suppliers.map(s => (
                                <option key={s._id} value={s._id}>
                                    {s.supplierName}
                                </option>
                            ))}
                        </select>
                    </div>


                    <div className="Buttons">
                        <div className="clear-button">
                            <button className="cancel-Product-button" onClick={handleClear}
                                type='button'
                                style={
                                    {
                                        cursor: "pointer"
                                    }
                                }
                            >
                                Clear
                            </button>
                        </div>
                        <div className="apply-button">
                            <button
                                className="add-Product-button"
                                type='button'
                                style={{
                                    border: "0px",
                                    borderRadius: "10px",
                                    padding: "10px",
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    color: "white",
                                    background: "linear-gradient(#A16A70, #D98484)",
                                    cursor: "pointer"
                                }}
                                onClick={handleApply}
                            >
                                Apply
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
};


export default PurchaseHeader;